"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileArbitraryEvent = void 0;
const triggerBeacon_1 = __importDefault(require("../beacon/triggerBeacon"));
const createEndEvent_1 = __importDefault(require("../events/createEndEvent"));
const performanceEntryUtils_1 = require("../utils/performanceEntryUtils");
/**
 * Profile a static event `eventName`: Measure elapsed time since the
 * document's [timeOrigin][] and queue the result to be sent with the next
 * beacon.
 *
 * Returns `true` if successful, `false` otherwise.
 *
 * _**Note:** Static events can only be profiled once per session.
 * Subsequent attempts to profile events of the same name will be ignored._
 *
 * [timeOrigin]: https://developer.mozilla.org/en-US/docs/Web/API/Performance/timeOrigin
 *
 * @param profiler ClientProfiler instance
 */
function profileEvent(profiler, eventName) {
    // Bail if we're not in a browser environment. See PERF-802.
    if (typeof window === 'undefined')
        return false;
    const { performance: perf } = window;
    const { eventEndQueue } = profiler;
    const isDupEvent = perf.getEntriesByName(eventName).length > 0;
    // Bail if no event name provided or it's a duplicate event name
    if (!eventName || isDupEvent)
        return false;
    // Mark the event in the browser's performance timeline and measure it now
    try {
        perf.mark(eventName);
        perf.measure(eventName, undefined, eventName);
    }
    catch (err) {
        // Some browsers older browsers treat `undefined` as 'null' and will
        // throw error like "Failed to execute 'measure' on 'Performance': The
        // mark 'null' does not exist", so catch the error and bail.
        console.error('Profile() failed:', err);
        return false;
    }
    // Format the result and add it to the end event queue to be sent with the
    // next beacon.
    const latestPerfEntry = (0, performanceEntryUtils_1.getLatestPerfEntryByName)(eventName);
    const eventEndObj = (0, performanceEntryUtils_1.perfEntryToEventEndObj)(latestPerfEntry);
    eventEndQueue.push(eventEndObj);
    // Return success!
    return true;
}
exports.default = profileEvent;
/**
 * Create a new event with an arbitrary value and beacon immediately.
 *
 * @param profiler ClientProfiler instance
 * @param eventName Name of the event to profile
 * @param value Value to profile
 *
 * @deprecated This functionality will be removed in a future release.
 */
function profileArbitraryEvent(profiler, eventName, value) {
    const { eventStartQueue, eventEndQueue } = profiler;
    if (!eventName) {
        console.warn('`eventName` cannot be falsey');
        return;
    }
    if (typeof value !== 'number') {
        console.warn('`value` must be a number');
        return;
    }
    eventStartQueue.push(eventName);
    eventEndQueue.push((0, createEndEvent_1.default)(eventName, value));
    (0, triggerBeacon_1.default)(profiler);
}
exports.profileArbitraryEvent = profileArbitraryEvent;
